import { useEffect, useState } from "react";

export default function useBatchedArray<Type>(initialState: Type[]):[Type[], (newState:Type[]) => void] {
  
    const [state, setState] = useState<Type[]>(initialState);

    const setBatchedState = (newState:Type[]):void => 
        setState(newState);
    return [state, setBatchedState];
}